export type ZodiacElement = "fire" | "earth" | "air" | "water";

export interface ZodiacSign {
  id: string;
  symbol: string;
  element: ZodiacElement;
  luckyNumbers: number[];
  cardColor: string;
  accentColor: string;
}

export const ZODIAC_SIGNS: ZodiacSign[] = [
  {
    "id": "aries",
    "symbol": "♈",
    "element": "fire",
    "luckyNumbers": [
      1,
      8,
      17
    ],
    "cardColor": "#FFF5F5",
    "accentColor": "#FC8181"
  },
  {
    "id": "taurus",
    "symbol": "♉",
    "element": "earth",
    "luckyNumbers": [
      2,
      6,
      9
    ],
    "cardColor": "#F0FFF4",
    "accentColor": "#68D391"
  },
  {
    "id": "gemini",
    "symbol": "♊",
    "element": "air",
    "luckyNumbers": [
      3,
      8,
      12
    ],
    "cardColor": "#FFFFF0",
    "accentColor": "#F6E05E"
  },
  {
    "id": "cancer",
    "symbol": "♋",
    "element": "water",
    "luckyNumbers": [
      2,
      7,
      11
    ],
    "cardColor": "#EBF8FF",
    "accentColor": "#63B3ED"
  },
  {
    "id": "leo",
    "symbol": "♌",
    "element": "fire",
    "luckyNumbers": [
      1,
      3,
      10
    ],
    "cardColor": "#FFFAF0",
    "accentColor": "#F6AD55"
  },
  {
    "id": "virgo",
    "symbol": "♍",
    "element": "earth",
    "luckyNumbers": [
      5,
      14,
      23
    ],
    "cardColor": "#F0FFF4",
    "accentColor": "#48BB78"
  },
  {
    "id": "libra",
    "symbol": "♎",
    "element": "air",
    "luckyNumbers": [
      6,
      15,
      24
    ],
    "cardColor": "#EBF8FF",
    "accentColor": "#76E4F7"
  },
  {
    "id": "scorpio",
    "symbol": "♏",
    "element": "water",
    "luckyNumbers": [
      8,
      11,
      18
    ],
    "cardColor": "#FFF5F5",
    "accentColor": "#FC8181"
  },
  {
    "id": "sagittarius",
    "symbol": "♐",
    "element": "fire",
    "luckyNumbers": [
      3,
      7,
      9
    ],
    "cardColor": "#FAF5FF",
    "accentColor": "#B794F4"
  },
  {
    "id": "capricorn",
    "symbol": "♑",
    "element": "earth",
    "luckyNumbers": [
      4,
      8,
      13
    ],
    "cardColor": "#FFFFF0",
    "accentColor": "#D69E2E"
  },
  {
    "id": "aquarius",
    "symbol": "♒",
    "element": "air",
    "luckyNumbers": [
      4,
      7,
      11
    ],
    "cardColor": "#EBF8FF",
    "accentColor": "#4299E1"
  },
  {
    "id": "pisces",
    "symbol": "♓",
    "element": "water",
    "luckyNumbers": [
      3,
      9,
      12
    ],
    "cardColor": "#EBF8FF",
    "accentColor": "#76E4F7"
  }
];

export const ELEMENT_COLORS = {
  "fire": {
    "bg": "#FFF5F5",
    "text": "#C53030",
    "badge": "#FED7D7"
  },
  "earth": {
    "bg": "#F0FFF4",
    "text": "#276749",
    "badge": "#C6F6D5"
  },
  "air": {
    "bg": "#FFFFF0",
    "text": "#975A16",
    "badge": "#FEFCBF"
  },
  "water": {
    "bg": "#EBF8FF",
    "text": "#2C5282",
    "badge": "#BEE3F8"
  }
};
